import { render } from "./MasterBoardStatusTasksModal.vue?vue&type=template&id=67af4ae4&scoped=true"
import script from "./MasterBoardStatusTasksModal.vue?vue&type=script&lang=js"
export * from "./MasterBoardStatusTasksModal.vue?vue&type=script&lang=js"

import "./MasterBoardStatusTasksModal.vue?vue&type=style&index=0&id=67af4ae4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67af4ae4"

export default script